import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import CloseIcon from '@mui/icons-material/Close';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import AddIcon from '@mui/icons-material/Add';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import CheckIcon from '@mui/icons-material/Check';
import ClearIcon from '@mui/icons-material/Clear';
import MenuIcon from '@mui/icons-material/Menu';
import MenuOpenIcon from '@mui/icons-material/MenuOpen';
import SettingsIcon from '@mui/icons-material/Settings';
import LogoutIcon from '@mui/icons-material/Logout';
import LanguageIcon from '@mui/icons-material/Language';
import WarningIcon from '@mui/icons-material/Warning';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import CloudDoneIcon from '@mui/icons-material/CloudDone';
import CloudOffIcon from '@mui/icons-material/CloudOff';
import ScheduleIcon from '@mui/icons-material/Schedule';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import PersonIcon from '@mui/icons-material/Person';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import SearchIcon from '@mui/icons-material/Search';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import NotificationsIcon from '@mui/icons-material/Notifications';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import LockIcon from '@mui/icons-material/Lock';
import PeopleIcon from '@mui/icons-material/People';
import CircleIcon from '@mui/icons-material/Circle';
import ReportProblemIcon from '@mui/icons-material/ReportProblem';

import { SvgIcon } from '@mui/material';

import ProbelistDashboardSvg from 'assets/icons/probelist-icon-dashboard.svg?react';
import ProbelistInspectionsSvg from 'assets/icons/probelist-icon-inspections.svg?react';
import ProbelistItemsSvg from 'assets/icons/probelist-icon-items.svg?react';
import ProbelistLogoutSvg from 'assets/icons/probelist-icon-logout.svg?react';
import ProbelistMenuHideSvg from 'assets/icons/probelist-icon-menu_hide.svg?react';
import ProbelistMenuShowSvg from 'assets/icons/probelist-icon-menu_show.svg?react';
import ProbelistNotificationsSvg from 'assets/icons/probelist-icon-notifications.svg?react';
import ProbelistObjectsSvg from 'assets/icons/probelist-icon-objects.svg?react';
import ProbelistPaymentSvg from 'assets/icons/probelist-icon-payment.svg?react';
import ProbelistProfileSvg from 'assets/icons/probelist-icon-profile.svg?react';
import ProbelistSettingsSvg from 'assets/icons/probelist-icon-settings.svg?react';
import ProbelistTemplatesSvg from 'assets/icons/probelist-icon-templates.svg?react';
import ProbelistUsersSvg from 'assets/icons/probelist-icon-users.svg?react';
import ProbelistWorkspaceSwitchSvg from 'assets/icons/probelist-icon-workspace_switch.svg?react';

const makeProbelistIcon = (component) => {
  const Icon = ({ sx, ...props }) => (
    <SvgIcon
      component={component}
      inheritViewBox
      sx={{
        fill: 'none',
        '& path, & circle, & rect, & line, & polyline, & ellipse': { stroke: 'currentColor' },
        ...sx,
      }}
      {...props}
    />
  );
  Icon.displayName = component.name || 'ProbelistIcon';
  return Icon;
};

const ProbelistDashboardIcon = makeProbelistIcon(ProbelistDashboardSvg);
const ProbelistInspectionsIcon = makeProbelistIcon(ProbelistInspectionsSvg);
const ProbelistItemsIcon = makeProbelistIcon(ProbelistItemsSvg);
const ProbelistLogoutIcon = makeProbelistIcon(ProbelistLogoutSvg);
const ProbelistMenuHideIcon = makeProbelistIcon(ProbelistMenuHideSvg);
const ProbelistMenuShowIcon = makeProbelistIcon(ProbelistMenuShowSvg);
const ProbelistNotificationsIcon = makeProbelistIcon(ProbelistNotificationsSvg);
const ProbelistObjectsIcon = makeProbelistIcon(ProbelistObjectsSvg);
const ProbelistPaymentIcon = makeProbelistIcon(ProbelistPaymentSvg);
const ProbelistProfileIcon = makeProbelistIcon(ProbelistProfileSvg);
const ProbelistSettingsIcon = makeProbelistIcon(ProbelistSettingsSvg);
const ProbelistTemplatesIcon = makeProbelistIcon(ProbelistTemplatesSvg);
const ProbelistUsersIcon = makeProbelistIcon(ProbelistUsersSvg);
const ProbelistWorkspaceSwitchIcon = makeProbelistIcon(ProbelistWorkspaceSwitchSvg);

export {
  CheckBoxOutlineBlankIcon,
  CheckBoxIcon,
  NotificationsIcon,
  AssignmentTurnedInIcon,
  LockIcon,
  PeopleIcon,
  CircleIcon,
  ReportProblemIcon,
  ScheduleIcon,
  ArrowForwardIcon,
  ArrowDropDownIcon,
  ArrowDropUpIcon,
  CloseIcon,
  DragIndicatorIcon,
  Visibility,
  VisibilityOff,
  AddIcon,
  FilterAltIcon,
  CheckIcon,
  ClearIcon,
  MenuIcon,
  MenuOpenIcon,
  SettingsIcon,
  LanguageIcon,
  LogoutIcon,
  WarningIcon,
  CloudUploadIcon,
  CloudDoneIcon,
  CloudOffIcon,
  PersonIcon,
  SwapHorizIcon,
  SearchIcon,
  ProbelistDashboardIcon,
  ProbelistInspectionsIcon,
  ProbelistItemsIcon,
  ProbelistLogoutIcon,
  ProbelistMenuHideIcon,
  ProbelistMenuShowIcon,
  ProbelistNotificationsIcon,
  ProbelistObjectsIcon,
  ProbelistPaymentIcon,
  ProbelistProfileIcon,
  ProbelistSettingsIcon,
  ProbelistTemplatesIcon,
  ProbelistUsersIcon,
  ProbelistWorkspaceSwitchIcon,
};
